// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2T1ZS","bigColWidth":"Table_bigColWidth__42mQg","biggerColWidth":"Table_biggerColWidth__1oR3B","row":"Table_row__2Kgv1","col":"Table_col__2nPAp"};